import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { isCollector } from "../../api/collect";
import { useIdentity } from "../../auth/useIdentity";

/**
 * A collector has no console (owner 2026-11-02: "no console access is
 * mandatory"): every console address sends it to its phone page. The gateway
 * refuses a collector everywhere else anyway; this only saves it a page of
 * refusals.
 */
export function CollectorGate({ children }: { children: ReactNode }) {
  const identity = useIdentity();
  if (isCollector(identity.roles)) return <Navigate to="/collect" replace />;
  return <>{children}</>;
}
